export const state = () => ({
    positions: [],
    position: null,
    positionsLoaded: false,
    loadingPosition: false,
});

export const mutations = {
    setPositions(state, positions) {
        state.positions = positions;
        state.loaded = true;
    },
    setPosition(state, position) {
        state.position = position;
    },
    setLoadingPosition(state, position) {
        state.loadingPosition = position;
    },
};

export const actions = {
    async fetchPositions(context, options) {
        try {
            const queryParams = new URLSearchParams({ ...options });

            let { data } = await this.$adminApi.get(`/employment/positions?${queryParams.toString()}`);
            if (data.data) {
                context.commit("setPositions", data.data);
            } else {
                context.commit("setPositions", data);
            }
            return data;
        } catch (error) {
            console.log("Failed to fetch positions: " + error);
        }
    },
    async fetchPosition(context, payload) {
        try {
            let { data } = await this.$adminApi.get(`/employment/positions/${payload}`);
            context.commit("setPosition", data);
        } catch (error) {
            console.log("Failed to fetch position: " + error);
            throw error;
        }
    },
};

export const getters = {
    getPositions(state) {
        return state.positions;
    },
    getPosition(state) {
        return state.position;
    },
    getLoaded(state) {
        return state.loaded;
    },
    getLoadingPosition(state) {
        return state.loadingPosition;
    },
};
